import { useState } from "react"

import NoticeSearch from "@/app/notice/NoticeSearch"
import NoticeTable from "@/app/notice/NoticeTable"

import "./notice.scss"

export default function Notice() {
  const [searchValue, setSearchValue] = useState("")
  const [page, setPage] = useState(0)

  return (
    <>
      <NoticeSearch searchValue={searchValue} setSearchValue={setSearchValue} />
      <NoticeTable searchValue={searchValue} page={page} setPage={setPage} />
    </>
  )
}
